var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.cClass,attrs:{"type":"button"},on:{"click":function($event){_vm.$listeners.click?_vm.$listeners.click():''}}},[_c('span',[_vm._t("default",function(){return [_vm._v("默认按钮")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }